import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'src/components'
import { LocalSettingsContext } from 'src/contexts'
import styles from './SidebarItem.scss'

/**
 * Sidebar item acting as a button. Use the `as` prop to render another element or component.
 */
const SidebarItem = ({ as: Wrapper, tooltip, ...domProps }) => {
  const { isSidebarCollapsed } = LocalSettingsContext.use()
  return (
    <Tooltip
      className={styles.item}
      title={tooltip}
      disabled={!isSidebarCollapsed}
      popperProps={{ placement: 'right' }}
    >
      <Wrapper {...domProps} />
    </Tooltip>
  )
}

SidebarItem.defaultProps = {
  as: 'button',
}

SidebarItem.propTypes = {
  /**
   * The navbar item wrapper.
   */
  as: PropTypes.elementType,
  /**
   * The collapsed tooltip title.
   */
  tooltip: PropTypes.node,
}

export default SidebarItem
